module.exports = "/assets/90e3b0501ff143bd058ecb3f754a4430.png";